import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import '../../styles/mobidawg-style.scss';
import { serviceSolutionList } from '../../datamodels/ServicesSolutions.ts';
import app from '../../services/firebase'; // Import the initialized app
import { getDatabase, ref } from 'firebase/database';

const database = getDatabase(app);

function HomeServicesSolutions() {
    // 1. Pre-filter and sort outer service solutions
    const visibleServices = serviceSolutionList
        .filter(serviceSolution => serviceSolution.isVisible ?? true)
        .sort((a, b) => a.id.localeCompare(b.id));

    const totalServices = visibleServices.length;

    return (
        <Box sx={{ width: '100%', mt: 2 }}>
            <Typography sx={{ 
                            height: '3rem', 
                            fontSize: '1.2rem', fontWeight: 'bold', 
                            m: '0rem', p: '0rem',
                            boxSizing: 'border-box',
                            display: 'flex',                
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundImage: 'conic-gradient(from 90deg,rgb(205, 236, 200) 10%,rgb(177, 205, 172) 80%,rgb(205, 236, 200) 29% )'}}>

                SERVICES and SOLUTIONS

            </Typography>
            
            <Grid container spacing={2} sx={{ mt: 0 }}>
                {visibleServices.map((serviceSolution, cardIndex) => {
                    // Check if this outer card is the last item AND total count is odd
                    const isLastOuterOdd = (totalServices % 2 !== 0) && (cardIndex === totalServices - 1);
                    const outerSpan = isLastOuterOdd ? 12 : 6;

                    // Pre-filter visible inner topics
                    const visibleTopics = serviceSolution.topics ? serviceSolution.topics.filter(t => t.isVisible) : [];
                    const totalTopics = visibleTopics.length;

                    return (
                        <Grid 
                            item 
                            xs={12} 
                            sm={12} 
                            md={outerSpan} 
                            lg={outerSpan} 
                            key={serviceSolution.id}
                        >
                            <Card sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <CardActionArea sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ padding: 0, flex: 1, width: '100%' }}>
                                        <Typography
                                            variant="h6"
                                            component="div"
                                            sx={{  
                                                color: '#c54a4a',                 
                                                padding: '0px 4px 2px 4px',     
                                                borderRadius: '4px',            
                                                m: '1rem', mb: '0.5rem',
                                                width: '100%',
                                                fontSize: '1.2rem',
                                                fontWeight: 'bold',
                                                boxSizing: 'border-box',
                                                display: 'flex',                
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                justifyContent: 'left',
                                                wordWrap: 'break-word',
                                                overflowWrap: 'break-word'
                                            }}>
                                            {serviceSolution.title}
                                        </Typography>                                        
                                        
                                        <Typography gutterBottom variant="body2" color="text.primary" sx={{ m:'1rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                            {serviceSolution.description}
                                        </Typography>

                                        {/* Inner Topics Grid */}
                                        <Grid container spacing={2} sx={{ p: '0 1rem 1rem 1rem' }}>
                                            {visibleTopics.map((t, topicIndex) => {
                                                // Check if this inner topic is the last item AND total topic count is odd
                                                const isLastTopicOdd = (totalTopics % 2 !== 0) && (topicIndex === totalTopics - 1);
                                                const topicSpan = isLastTopicOdd ? 12 : 6;

                                                return (
                                                    <Grid 
                                                        item 
                                                        xs={12} 
                                                        sm={12} 
                                                        md={topicSpan} 
                                                        lg={topicSpan}  
                                                        key={t.id} 
                                                        sx={{ display: 'flex', alignItems: 'flex-start' }}
                                                    >
                                                        {t.icon && (
                                                            <t.icon sx={{ width: 28, height: 28, mr: '1rem', mt: '0.2rem', flexShrink: 0 }} />
                                                        )}
                                                        <Box>
                                                            <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
                                                                {t.name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontSize: '0.9rem', overflowWrap: 'break-word' }} >
                                                                {t.description}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
}

export default HomeServicesSolutions;